import CONFIG from 'Config';
import store from 'Store';
import state from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export default module;

export function registerModuleMarket() {
  if (!store.hasModule('market')) {
    store.registerModule('market', module);
    if (CONFIG.isMarketEnabled) {
      store.dispatch('market/setupNotification', null, { root: true });
    }
  }
}

export function unregisterModuleMarket() {
  if (store.hasModule('market')) {
    if (CONFIG.isMarketEnabled) {
      store.dispatch('market/resetMarket', null, { root: true });
    }
    store.unregisterModule('market');
  }
}
